import { BANNER_SLICE_NAME } from 'store/slices/slicesNames';

/** @returns {boolean} True if the banner should be shown */
export const showBanner = (state) => state[BANNER_SLICE_NAME].showBanner;

export const variant = (state) => state[BANNER_SLICE_NAME].variant;
export const text = (state) => state[BANNER_SLICE_NAME].text;
export const color = (state) => state[BANNER_SLICE_NAME].color;
export const hasDismissed = (state) => state[BANNER_SLICE_NAME].hasDismissed;
